import { Fragment, useState, useEffect } from 'react';
import '../styles.scss';
import { SettingOutlined } from '@ant-design/icons';
import MegaTable from '../../../components/MagaTableV2';
import { mixGetV2 } from '../../../services/mixin'

const TabTableDetail = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.survey_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSurveyInformationDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { headerName: 'Số khung (VIN)', field: 'chassis_no' },
      // { headerName: 'Biển số xe', field: 'number_plate' },
      // { headerName: 'Số máy', field: 'Số máy' },
      // { headerName: 'Màu xe', field: 'Màu xe' },
      // { headerName: 'Loại động cơ', field: 'Loại động cơ' },
      // { headerName: 'Ngày mua xe', field: 'Ngày mua xe' },
      // { headerName: 'Ngày ký HĐ', field: 'Ngày ký HĐ' },
      // { headerName: 'Số HĐ', field: 'Số HĐ' },
      // { headerName: 'Ngày giao xe', field: 'Ngày giao xe' },
      // { headerName: 'Số Km hiện tại', field: 'present_mile_age' },
      // { headerName: 'Số LSC', field: 'Số LSC' },
      // { headerName: 'Đã nhắc BD 1000km', field: 'Đã nhắc BD 1000km' },
      // { headerName: 'Ngày nhắc BD', field: 'Ngày nhắc BD' },
      // { headerName: 'Đã vào bảo dưỡng 1000km', field: 'Đã vào bảo dưỡng 1000km' },
      // { headerName: 'Câu hỏi khảo sát', field: 'Câu hỏi khảo sát' },
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/survey?id_survey=${id}`);
    if (res.data) {
      stChange({ ...stData, thongtinkhaosat_show_detail: res.data }, 'detailSurveyInformation');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.thongtinkhaosat_show && stData.thongtinkhaosat_show.id) {
      getDetail(stData.thongtinkhaosat_show.id);
    }
  }, [stData.thongtinkhaosat_show]);

  return (
    <Fragment>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}
            >
              <SettingOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.thongtinkhaosat_show_detail ? [stData.thongtinkhaosat_show_detail] : [], loading: loading }}
            stChange={(data = {}, type = '') => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
        </div>
      </div>
    </Fragment>
  )

}

export default TabTableDetail
